import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import {
    GetRateioCentroCustoResponse,
    CreateRateioCentroCustoResponse,
} from '../../responses/financas/get-rateio-centro-custo.response';
import { RateioCentroCustoRequest } from '../../requests/financas/rateio-centro-custo.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class RateioCentroCustoService extends CommonService {
    private readonly apiUrl: string = environment.urlApiFinancas + 'RateioCentroCusto';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getAll(pesquisa: string = '', pagina: number = 0, tamanhoPagina: number = 20): Observable<GetRateioCentroCustoResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (pesquisa) {
            params = params.set('pesquisa', pesquisa);
        }

        return this.httpClient
            .get<GetRateioCentroCustoResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    public getById(id: number): Observable<CreateRateioCentroCustoResponse> {
        const url = `${this.apiUrl}/idRateioCentroCusto/${id}`;
        return this.httpClient
            .get<CreateRateioCentroCustoResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public create(request: RateioCentroCustoRequest): Observable<CreateRateioCentroCustoResponse> {
        return this.httpClient
            .post<CreateRateioCentroCustoResponse>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(id: number, request: RateioCentroCustoRequest): Observable<CreateRateioCentroCustoResponse> {
        const url = `${this.apiUrl}/idRateioCentroCusto/${id}`;
        return this.httpClient
            .put<CreateRateioCentroCustoResponse>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public delete(id: number): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/idRateioCentroCusto/${id}`;
        return this.httpClient
            .delete<ReturnStruct>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public deleteBulk(ids: number[]): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/bulk-delete`;
        return this.httpClient
            .post<ReturnStruct>(url, { ids }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
